import { gql } from '@apollo/client';

const ASSOCIATE_FAX_TO_CLINIC_MUTATION = gql `
  mutation SaveFaxClinicAssociation($faxId: ID!, $clinicId: ID!) {
    save_fax_clinic_association(fax_id: $faxId, clinic_id: $clinicId) {
        id
        name 
    }
  }
`;

export {
    ASSOCIATE_FAX_TO_CLINIC_MUTATION,
};
